import type { VenueId } from '@beat-venues/common-types';
import { type VariantProps, cva } from 'class-variance-authority';
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { Container, Flock } from '../../';
import type { CommonProps } from '../../types';

export interface FlocksProps
    extends CommonProps,
        VariantProps<typeof FlocksStyles> {
    venue: VenueId;
    composition?: 'default' | 'footer' | 'home';
    children?: ReactNode;
}

export const FlocksStyles = cva('relative hidden xl:block -z-10');

export const Flocks = ({
    className,
    venue,
    composition = 'default',
    testId = 'flock-composition',
    children,
}: FlocksProps): JSX.Element => {
    return (
        <div className="overflow-hidden" data-testid={testId}>
            {composition === 'footer' ? (
                <Container
                    className={twMerge(
                        FlocksStyles({
                            className,
                        })
                    )}
                >
                    {/* Left */}
                    <Flock
                        className="top-[80px] left-[-78px] w-[120px] rotate-45"
                        venue={venue}
                    />
                    <Flock
                        className="top-[237px] left-[0px] w-[57px] rotate-[-75deg]"
                        venue={venue}
                    />
                    <Flock
                        className="top-[262px] left-[-29px] w-[542px] -rotate-45"
                        venue={venue}
                    />
                    {/* Right */}
                    <Flock
                        className="top-[222px] right-[-80px] w-[152px] translate-x-[100%] rotate-[60deg]"
                        venue={venue}
                    />
                    <Flock
                        className="top-[401px] right-[-227px] w-[57px] translate-x-[100%]"
                        venue={venue}
                    />
                </Container>
            ) : composition === 'home' ? (
                <Container className={twMerge(FlocksStyles({ className }))}>
                    {/* Left */}
                    <Flock
                        className="top-[42px] left-[-42px] w-[152px] -rotate-45"
                        venue={venue}
                    />
                    <Flock
                        className="top-[236px] left-[-75px] w-[44px] -rotate-45"
                        venue={venue}
                    />
                    <Flock
                        className="top-[96px] left-[-149px] w-[554px] -rotate-45"
                        venue={venue}
                    />
                    {/* Right */}
                    <Flock
                        className="top-[96px] right-[45px] w-[175px] translate-x-[100%]"
                        venue={venue}
                    />
                    <Flock
                        className="top-[353px] right-[-107px] w-[462px] translate-x-[100%] -rotate-45"
                        venue={venue}
                    />
                </Container>
            ) : (
                <Container className={twMerge(FlocksStyles({ className }))}>
                    {/* Left */}
                    <Flock
                        className="top-[82px] left-[-62px] w-[139px] -rotate-45"
                        venue={venue}
                    />
                    <Flock
                        className="top-[278px] left-[38px] w-[77px] -rotate-45"
                        venue={venue}
                    />
                    <Flock
                        className="top-[168px] left-[-185px] w-[508px] -rotate-45"
                        venue={venue}
                    />
                    {/* Right */}
                    <Flock
                        className="top-[343px] right-[-113px] w-[325px] translate-x-[100%] -rotate-45"
                        venue={venue}
                    />
                </Container>
            )}

            {children}
        </div>
    );
};
